var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "matrix(0.856831, 0, 0, 0.856831, 0, 0)",
      transformOrigin: "50% 50%",
      cursor: "move",
      transition: "transform 200ms ease-in-out 0s"
    },
    width: 710,
    height: 786,
    viewBox: "0 0 7100 7860",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l634uqlqDQu0Xtod4xWIRM8",
    fill: "rgb(255,255,255)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prV3lN0ZS",
    d: "M2737 4353 c-30 -54 -152 -266 -271 -472 l-216 -374 0 -36 0 -36 88 -151 c48 -83 170 -296 272 -472 l185 -322 566 0 567 0 20 18 20 17 261 453 261 453 0 38 0 39 -272 471 -271 471 -577 0 -577 0 -56 -97z m534 -462 l-13 -9 -9 -43 -8 -44 0 -145 c0 -80 4 -192 8 -250 l9 -105 -8 -8 -7 -8 -14 17 -14 17 0 271 0 271 13 23 13 22 22 0 22 0 -14 -9z m14 -905 l15 -23 -6 -17 -6 -16 -19 0 -18 0 -11 21 -12 21 18 19 c21 24 20 24 39 -5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pdkIjTFmp",
    d: "M2800 655 c0 -3 5 -15 10 -26 l11 -19 20 0 20 0 -3 23 -3 22 -27 3 -28 3 0 -6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l49XfqsEp2qIQmcINk1aSEv",
    fill: "rgb(202,191,103)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "p4TZyYZHM",
    d: "M1690 2529 l0 -27 147 -258 c80 -143 191 -335 246 -429 55 -93 109 -187 121 -207 l21 -38 23 0 23 0 5 -15 6 -15 559 0 559 0 0 33 0 33 -17 24 c-10 13 -45 74 -79 135 -33 60 -144 254 -246 430 l-186 320 -25 3 -26 3 -5 17 -6 17 -560 0 -560 0 0 -26z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l70AUDgz5c0dGbpmx8wlo5k",
    fill: "rgb(250,184,0)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "p15sF1FYG6",
    d: "M4440 5379 l0 -35 101 -175 c56 -95 137 -237 182 -314 44 -77 120 -207 168 -290 l87 -150 39 -3 38 -2 39 67 c21 38 104 181 183 318 238 411 300 519 305 535 l5 15 -9 18 -9 17 -546 0 -545 -1 -19 17 -19 17 0 -34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "pTVmOvS2t",
    d: "M651 2576 l-21 -33 0 -21 0 -21 166 -288 c92 -158 209 -362 261 -453 52 -91 101 -171 107 -178 l12 -13 539 1 539 0 5 6 6 5 -26 47 c-14 26 -63 110 -108 186 -46 77 -122 209 -171 295 -48 86 -122 216 -163 289 l-76 132 25 -6 24 -6 0 10 c0 6 -5 14 -11 18 l-12 7 -528 -2 -529 -2 0 30 0 31 -9 0 c-5 0 -19 -15 -30 -34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "pZj3UB8KD",
    d: "M3921 2539 l-23 -19 -535 0 -535 0 6 -16 c3 -8 90 -160 192 -337 103 -177 215 -371 248 -432 34 -60 70 -122 80 -138 l18 -27 -22 0 -22 0 4 -12 5 -13 558 -3 559 -2 9 15 8 15 24 0 25 0 0 35 0 35 -20 0 -19 0 -69 117 c-161 275 -379 653 -415 720 -21 40 -41 74 -45 77 l-7 4 -24 -19z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l44HSG2EJrYzMUJf5e2ibB1",
    fill: "rgb(35,184,202)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "p1ArvdeuBq",
    d: "M3745 6108 c-71 -123 -189 -327 -262 -454 l-133 -231 0 -31 0 -30 14 -11 13 -11 556 2 556 3 -69 120 c-38 66 -165 287 -282 490 l-214 370 -25 3 -25 3 -129 -223z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "pcLF3Mnfg",
    d: "M1163 3468 l3 -55 74 -129 c41 -71 156 -271 256 -444 l182 -315 562 -3 563 -3 8 8 7 8 -185 320 c-102 176 -223 385 -269 465 l-85 145 4 16 5 17 -522 6 -521 5 -42 7 -42 6 2 -54z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "pPdJB7xtq",
    d: "M2286 1538 c9 -18 72 -127 139 -243 67 -116 175 -302 240 -415 65 -113 129 -220 142 -237 l24 -33 544 0 545 0 16 25 17 26 -15 12 c-8 7 -129 211 -269 454 l-254 443 -573 0 -573 0 17 -32z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l2QraxBhQH4RMRqaXOy6X59",
    fill: "rgb(241,146,15)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "pPZup1xES",
    d: "M5550 5360 c0 -6 -33 -68 -73 -138 -40 -70 -126 -219 -191 -332 -116 -202 -256 -440 -264 -450 -2 -3 -11 5 -19 18 -9 12 -19 22 -24 22 l-9 0 0 -33 0 -33 103 -180 c57 -98 177 -307 267 -464 90 -157 170 -293 178 -302 l15 -18 24 0 24 0 -3 13 -3 12 49 85 c27 47 150 259 273 472 l224 388 -12 22 c-7 13 -119 208 -249 433 -130 226 -247 429 -260 453 l-24 42 -13 0 -13 0 0 -10z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "pqUR8gwUk",
    d: "M1150 3505 l21 -35 -49 -82 c-27 -46 -95 -164 -152 -263 -57 -99 -141 -245 -188 -325 -47 -80 -98 -171 -114 -202 l-29 -58 6 -10 6 -10 522 0 522 0 14 9 15 9 -11 14 c-11 13 -480 824 -508 877 -8 17 -15 38 -15 48 l0 17 12 -12 c7 -7 15 -12 18 -12 l7 0 -5 29 -4 29 -22 6 c-11 3 -31 6 -44 6 l-24 0 22 -35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "pnMCTlIkd",
    d: "M4457 3482 l5 -19 -263 -454 c-144 -250 -265 -459 -270 -465 l-9 -11 43 -79 c49 -90 314 -549 421 -729 l71 -120 17 1 17 2 -10 -19 -10 -19 19 0 19 0 20 22 c11 13 54 81 95 153 76 131 205 356 350 606 l78 136 0 32 0 32 -154 267 c-213 370 -296 515 -348 602 l-44 75 -26 3 -26 3 5 -19z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6SbOEBfkF4M4ngkN03v9x0",
    fill: "rgb(212,0,123)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "pLsTl7lYe",
    d: "M2280 5390 l0 -10 -35 0 -35 0 -6 -25 c-3 -14 -9 -25 -13 -25 -4 0 -24 -33 -46 -72 -21 -40 -72 -130 -112 -201 -40 -70 -73 -134 -73 -141 0 -7 -9 -25 -20 -38 -11 -14 -24 -36 -30 -49 -11 -26 -27 -51 -77 -123 -18 -26 -33 -49 -33 -52 0 -3 -16 -38 -35 -77 l-35 -71 0 -35 1 -36 13 -17 13 -18 526 0 526 0 6 10 6 10 28 0 28 0 53 98 c29 53 97 171 150 262 53 91 140 240 193 332 l97 168 0 48 0 48 -12 12 -12 12 -533 0 -533 0 0 -10z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "pxMFQJ4SR",
    d: "M4945 4358 c-39 -55 -314 -531 -389 -673 -12 -22 -42 -71 -68 -110 l-47 -70 23 -30 c23 -31 98 -159 341 -580 76 -132 152 -265 170 -295 l31 -55 19 -4 18 -3 38 43 c49 57 80 106 202 324 55 99 120 214 145 255 25 41 56 98 69 125 l25 50 34 23 34 22 0 34 0 34 -27 33 c-15 18 -98 154 -183 303 -86 149 -198 344 -250 434 l-94 162 -37 0 -38 0 -16 -22z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ltEWdv9HDb5WPy7bRP4lPI",
    fill: "rgb(223,1,96)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "pYpizgpF0",
    d: "M4395 5317 c-17 -23 -55 -86 -85 -140 -30 -55 -59 -106 -65 -115 -5 -10 -25 -44 -44 -77 -19 -33 -64 -112 -101 -175 -37 -63 -100 -170 -139 -237 l-71 -122 0 -15 0 -15 15 -3 15 -3 267 -464 268 -464 10 -4 11 -3 44 67 c25 38 54 86 66 108 71 135 351 619 390 673 l16 24 23 -6 22 -6 6 6 5 6 -29 61 c-26 56 -73 138 -269 477 -37 63 -113 195 -169 293 l-103 177 -27 -1 -26 0 -30 -42z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "p1Fu409R4W",
    d: "M652 4444 l-23 -6 3 -22 3 -22 255 -442 255 -442 20 -6 c11 -4 28 -13 38 -22 l17 -15 6 6 c3 3 25 38 48 79 23 40 131 226 239 414 l197 341 0 56 0 56 -20 11 -20 11 -497 4 -498 4 -23 -5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "pF5AHG5oG",
    d: "M5558 3446 l4 -34 -35 -24 -35 -23 -25 -50 c-13 -27 -44 -84 -69 -125 -25 -41 -90 -156 -145 -255 -122 -218 -153 -267 -202 -324 l-38 -43 -21 27 c-12 15 -22 32 -22 36 0 5 -4 9 -10 9 l-9 0 34 -59 35 -60 -11 -24 -11 -24 36 -74 c19 -41 65 -123 101 -184 35 -60 99 -171 141 -245 97 -170 199 -338 223 -367 l19 -23 30 0 30 0 178 307 c97 170 220 381 272 471 l94 162 -277 480 c-153 264 -281 480 -284 480 l-7 0 4 -34z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3O2Wilpho2pZhycA6RYvr4",
    fill: "rgb(185,21,100)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "p18ssN57bS",
    d: "M2233 5383 l-53 -4 0 -55 0 -54 8 0 c11 0 39 35 47 59 l6 21 25 6 24 6 0 14 c0 8 -1 13 -2 12 -2 -1 -27 -3 -55 -5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "p1CAQSwJXJ",
    d: "M4432 5372 l-32 -3 -15 -29 -15 -29 0 -41 0 -40 8 0 c4 0 23 22 42 50 l35 49 18 1 17 0 0 8 c0 5 -6 15 -12 23 l-13 14 -33 -3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "piydIiVXB",
    d: "M1930 4898 c-11 -18 -20 -38 -20 -45 0 -6 -4 -13 -8 -15 -4 -1 -18 -22 -30 -46 l-22 -43 0 -34 0 -35 6 0 c8 0 43 41 55 65 5 11 20 38 34 60 13 22 29 51 36 65 6 14 15 33 20 43 l9 17 -30 0 -30 0 -20 -32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "piND1hk6l",
    d: "M1757 4593 c-20 -43 -39 -88 -42 -100 l-6 -23 -32 -1 c-18 -1 -211 -1 -431 0 l-398 2 -82 15 c-44 8 -86 14 -91 14 l-10 0 -19 -34 -18 -34 6 -20 7 -21 36 15 35 15 465 -6 466 -6 19 -10 20 -11 -4 -34 -4 -34 23 0 22 0 23 40 23 40 33 0 32 0 0 15 0 15 -17 1 c-10 1 -22 0 -28 -1 l-10 -2 7 8 8 7 -17 12 -17 12 37 76 c20 42 37 79 37 83 0 4 7 16 17 26 l16 18 -34 0 -35 0 -37 -77z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "pp2b9MPX0",
    d: "M5440 1713 c1 -16 9 -53 20 -83 l19 -55 41 -3 41 -3 15 12 c8 6 14 15 14 20 l0 9 -21 0 -22 0 -14 18 c-8 9 -28 38 -44 65 -17 26 -35 47 -40 47 l-9 0 0 -27z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3pH9Nhl7QIsUb2i1k7G2Ua",
    fill: "rgb(168,27,100)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "pt1of2khd",
    d: "M2284 5396 l-6 -16 -548 0 -547 0 -15 -17 c-24 -28 -518 -890 -518 -904 l0 -13 10 10 11 11 77 -15 77 -15 447 -1 448 -1 1 -10 c1 -5 1 -16 0 -22 l-2 -13 31 0 30 0 0 20 0 20 -21 0 -21 0 7 33 c4 17 23 64 42 102 l35 70 15 8 14 9 36 76 c19 42 39 79 43 82 4 3 11 15 15 28 4 13 19 38 34 55 26 31 80 123 183 310 l48 88 0 35 0 34 38 0 c20 0 47 3 60 6 l23 7 -3 16 -3 16 -18 3 -17 3 -6 -15z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "pE8o9hQcd",
    d: "M3290 5387 l0 -12 23 -10 22 -10 3 -22 3 -21 -97 -169 c-54 -92 -141 -242 -194 -333 -125 -213 -206 -362 -203 -372 l3 -8 -20 0 -20 0 0 -7 0 -8 555 3 555 2 71 123 c39 67 102 174 139 237 37 63 82 142 101 175 19 33 39 67 44 76 38 64 125 228 125 238 0 6 9 30 20 51 l20 40 22 0 21 0 -5 5 -5 6 -535 -1 -535 0 -13 15 -12 15 -44 0 -44 0 0 -13z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "p1HHAuAjLE",
    d: "M4933 2367 c-45 -78 -129 -225 -188 -327 -59 -102 -127 -221 -153 -265 -65 -115 -124 -205 -134 -205 -4 0 -8 -5 -8 -12 l0 -12 12 12 12 12 550 1 c303 1 539 4 525 6 l-26 4 -13 24 -13 24 7 16 6 16 -8 -5 -8 -5 -13 36 c-8 20 -33 68 -56 107 -23 39 -77 132 -119 206 -42 74 -106 185 -141 245 -36 61 -81 142 -100 182 -19 40 -39 74 -43 77 l-7 4 -82 -141z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4aKWsV9TEkAH6ThrzLHP4g",
    fill: "rgb(0,139,153)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "pkDDmPEql",
    d: "M2813 6318 c-5 -7 -126 -215 -268 -461 l-257 -448 -2 -17 -1 -17 559 -3 559 -2 -11 13 -11 13 78 134 c43 74 156 270 251 435 95 165 181 312 191 326 l18 26 -6 7 -6 6 -542 0 -543 0 -9 -12z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "pN2gH5UAR",
    d: "M1727 4406 c-18 -20 -225 -374 -494 -842 l-41 -73 11 -9 12 -9 530 -2 530 -2 190 328 c104 180 227 393 272 473 l84 145 42 6 42 6 -578 1 -578 2 -22 -24z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "p1HNgdeQcL",
    d: "M3923 1570 l-553 -5 273 -472 272 -473 16 18 c14 15 260 436 471 806 37 66 73 123 80 128 l13 8 -10 -3 c-5 -1 -259 -4 -562 -7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l5O4ByJXpXQgviCQLcj5AFg",
    fill: "rgb(0,0,255)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "pDAl8lWEU",
    d: "M3218 3930 l-17 -11 -11 -37 -10 -37 0 -47 0 -47 -17 -10 -18 -9 17 -19 16 -18 4 -206 3 -206 14 -16 13 -17 32 0 c17 0 37 4 44 8 l12 8 -11 60 -11 59 -2 210 -1 210 8 28 7 27 50 0 49 0 26 -10 27 -10 -4 12 -4 13 -65 33 -64 32 -35 5 -35 5 -17 -10z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "pEW0l59RL",
    d: "M3250 3042 c-8 -2 -23 -11 -32 -20 l-18 -15 0 -39 0 -38 20 -20 20 -20 29 0 30 0 15 15 c8 8 18 24 21 35 l6 20 -18 37 -18 36 -20 7 -20 7 -15 -5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "texts",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a45bf61010f4ecaf8817d31fdbad2354.svg";
export { ForwardRef as ReactComponent };